
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.855 7.246L1.688.579a.833.833 0 00-1.163.956l1.01 4.04L8 8l-6.465 2.424-1.01 4.041a.832.832 0 001.163.956l14.167-6.667a.833.833 0 000-1.508z","fill":"#3581F3"}})])
          )
        }
      }
    